import React from "react";

export default function MSAccess_Sqr() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Sqr</h1>
      <p>This is the MSAccess_Sqr component generated from the SQL JSON.</p>
    </div>
  );
}
